import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
  const theme = useTheme();
  const PRIMARY_LIGHT = theme.palette.primary.light;
  const PRIMARY_MAIN = theme.palette.primary.main;
  const PRIMARY_DARK = theme.palette.primary.dark;
  const logo = (
    <Box sx={{ width: 40, height: 40, ...sx }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%"  viewBox="0 0 1024.000000 1024.000000">
        <defs>
          <linearGradient id="BG1" x1="100%" x2="50%" y1="9.946%" y2="50%">
            <stop offset="0%" stopColor={PRIMARY_DARK} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG2" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG3" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
        </defs>
        <g
          fill={PRIMARY_MAIN} stroke="none" strokeWidth="1" fillRule="evenodd"  transform="translate(0.000000,1024.000000) scale(0.100000,-0.100000)">
<path d="M4892 9260 c-833 -49 -1590 -325 -2242 -818 -674 -510 -1171 -1203
-1439 -2008 -153 -457 -225 -1032 -192 -1514 45 -644 213 -1222 510 -1755 463
-828 1209 -1487 2077 -1834 875 -349 1878 -382 2774 -89 810 264 1516 777
2041 1483 334 448 569 960 698 1520 171 738 137 1469 -101 2205 -138 428 -417
941 -690 1271 -35 42 -75 90 -90 108 -65 80 -242 263 -347 359 -659 602 -1469
968 -2341 1056 -190 20 -480 26 -658 16z m623 -525 c366 -43 673 -123 1005
-260 448 -185 900 -503 1229 -865 149 -164 153 -170 259 -311 126 -169 200
-287 295 -470 368 -701 493 -1471 367 -2246 -152 -927 -651 -1752 -1405 -2320
-491 -370 -1054 -599 -1690 -688 -638 -89 -1325 14 -1937 291 -649 294 -1219
798 -1587 1405 -268 443 -442 943 -508 1461 -25 193 -25 683 0 868 59 446 166
791 369 1191 174 346 394 645 679 926 156 153 230 216 394 340 544 407 1205
647 1925 697 108 8 477 -4 605 -19z"/>
<path d="M4825 8639 c-163 -13 -460 -66 -625 -111 -494 -136 -923 -360 -1320
-691 -112 -93 -371 -353 -451 -452 -418 -517 -671 -1081 -770 -1721 -30 -199
-38 -647 -15 -863 21 -193 37 -285 82 -467 124 -508 355 -973 692 -1394 109
-135 407 -431 537 -531 61 -47 166 -123 235 -169 69 -46 138 -92 154 -103 88
-60 507 -257 547 -257 5 0 8 73 7 169 l-2 170 218 111 c120 61 220 109 223
107 2 -3 5 -161 6 -353 l2 -349 50 -11 c28 -6 65 -14 83 -17 l32 -7 0 413 c0
226 0 419 0 429 0 13 5 12 28 -8 15 -13 114 -82 220 -154 l193 -130 -1 -294
-1 -294 63 -7 c35 -4 77 -5 93 -3 l30 3 2 395 c1 394 1 394 23 412 12 10 17
18 10 18 -9 0 -7 6 5 20 9 10 15 26 12 33 -4 10 2 14 19 15 23 0 24 -2 9 -18
-27 -29 -16 -31 17 -3 45 40 160 155 178 178 8 11 -2 5 -21 -12 -34 -32 -57
-44 -44 -23 3 6 -3 10 -14 10 -12 0 -21 -4 -21 -9 0 -5 -9 -11 -20 -14 -11 -3
-20 -10 -20 -17 0 -6 6 -8 13 -4 9 5 9 4 0 -6 -9 -10 -15 -10 -27 2 -14 14
-13 18 4 33 21 19 26 35 11 35 -6 0 -18 -13 -28 -30 -9 -16 -23 -30 -30 -30
-7 0 -13 -6 -13 -12 0 -10 -2 -10 -9 0 -6 9 7 29 40 63 27 28 49 56 49 62 0 7
-17 -6 -38 -28 -21 -22 -91 -89 -156 -150 -66 -60 -125 -116 -132 -122 -18
-18 -18 -18 -90 33 -35 25 -64 40 -64 34 0 -7 -7 -10 -15 -6 -8 3 -26 1 -40
-4 -22 -8 -27 -6 -41 21 -10 20 -11 28 -3 24 8 -5 10 -4 5 4 -4 7 -17 9 -29 6
-17 -5 -19 -4 -7 4 23 16 36 13 68 -14 17 -14 35 -25 42 -25 16 0 -10 20 -130
101 -146 97 -131 93 -191 62 -28 -15 -46 -29 -40 -31 15 -5 4 -22 -15 -22 -8
0 -12 5 -9 10 6 10 -63 -25 -225 -113 -30 -16 -178 -92 -328 -169 -250 -128
-328 -159 -262 -106 68 54 339 322 334 330 -3 5 -1 7 4 6 6 -2 58 43 116 100
58 57 97 101 87 97 -11 -3 -29 4 -47 20 -16 14 -37 25 -47 25 -10 0 -20 7 -23
15 -4 10 -20 15 -45 15 -32 0 -37 3 -32 17 5 15 4 16 -8 7 -8 -6 -22 -11 -31
-11 -13 0 -15 4 -7 18 11 22 29 34 29 20 0 -5 -6 -11 -12 -14 -7 -2 -9 -8 -5
-13 11 -12 28 17 21 38 -3 11 3 22 15 30 12 7 21 17 21 22 0 14 -45 -31 -90
-89 -37 -48 -39 -52 -29 -91 21 -83 -29 -154 -108 -154 -73 0 -112 41 -113
116 0 44 5 57 30 84 17 18 28 35 25 39 -4 3 -19 -9 -35 -27 -27 -31 -28 -31
-26 -8 0 13 4 22 9 19 4 -2 20 9 36 26 22 23 38 31 64 31 20 0 37 5 39 11 2 7
16 13 31 15 29 3 28 -4 -2 -40 -12 -15 -13 -18 -2 -14 8 2 34 30 59 61 36 46
43 60 33 70 -10 9 -15 8 -25 -5 -8 -12 -27 -18 -50 -18 -33 0 -36 2 -36 30 0
28 -2 30 -40 30 -36 0 -40 3 -40 25 0 19 -5 25 -21 25 -24 0 -58 37 -59 64 0
17 -7 18 -82 13 -46 -3 -75 -4 -65 -1 23 7 25 84 2 84 -8 0 -15 7 -15 15 0 11
-11 15 -40 15 -36 0 -40 3 -40 25 0 23 -4 25 -40 25 l-40 0 0 40 0 40 -40 0
-40 0 0 40 c0 36 -2 40 -25 40 -22 0 -25 4 -25 40 l0 40 -55 0 -55 0 0 80 c0
79 0 80 -25 80 -22 0 -25 4 -25 40 l0 40 -55 0 -55 0 0 40 c0 29 4 40 15 40
11 0 15 11 15 40 l0 40 -40 0 -40 0 0 80 c0 63 -3 80 -14 80 -10 0 -16 -13
-19 -37 -2 -21 -2 -3 1 40 l4 77 -26 0 c-24 0 -26 4 -26 40 0 34 -3 40 -21 40
-20 0 -21 3 -14 80 l7 80 -26 0 c-26 0 -26 1 -26 79 0 67 -3 80 -17 84 -10 3
2 6 27 7 l45 3 -45 6 c-144 21 294 26 2350 26 2387 0 2531 -1 2527 -18 -1 -5
9 -13 23 -17 30 -7 35 -42 25 -167 l-7 -83 -54 0 -54 0 0 -40 c0 -33 3 -40 20
-40 17 0 20 -7 20 -40 l0 -40 -46 0 -46 0 4 -77 c3 -43 3 -61 1 -40 -6 53 -33
51 -33 -3 0 -36 -2 -40 -25 -40 -25 0 -25 -1 -25 -80 l0 -80 -49 0 -50 0 -3
-37 c-3 -33 -7 -38 -30 -41 -28 -3 -28 -4 -28 -77 0 -78 -5 -85 -56 -85 -21 0
-24 -4 -24 -40 0 -22 -4 -40 -10 -40 -5 0 -10 -16 -10 -35 0 -19 -3 -35 -7
-36 -5 -1 -19 -2 -33 -3 -14 -2 -42 -20 -62 -40 -43 -43 -44 -46 -23 -46 11 0
15 -11 15 -40 0 -29 -4 -40 -15 -40 -9 0 -15 9 -15 25 0 14 -4 25 -10 25 -5 0
-10 -9 -10 -20 0 -15 -9 -22 -30 -26 -27 -6 -30 -10 -30 -45 l0 -39 -65 0 -65
0 0 -40 0 -40 -45 0 c-38 0 -45 -3 -45 -20 0 -11 -4 -20 -10 -20 -5 0 -10 -9
-10 -20 0 -13 -7 -20 -20 -20 -11 0 -20 -4 -20 -10 0 -5 -9 -10 -20 -10 -11 0
-20 -6 -20 -13 0 -20 -33 -47 -58 -47 -13 0 -22 -6 -22 -15 0 -11 -11 -15 -40
-15 -36 0 -40 -2 -40 -25 0 -22 -4 -25 -40 -25 -23 0 -40 -5 -40 -11 0 -6 -12
-20 -26 -31 -15 -12 -23 -26 -19 -35 5 -16 -11 -43 -26 -43 -4 0 -10 26 -12
58 -3 53 -3 51 -7 -23 -3 -71 -4 -62 -15 85 -11 158 -12 143 -16 -390 -4 -566
-3 -730 6 -738 14 -15 342 123 542 228 168 88 450 275 555 368 176 155 232
207 310 286 170 172 332 381 475 611 79 128 77 123 158 285 352 702 455 1529
284 2295 -167 752 -555 1397 -1149 1909 -110 94 -159 133 -238 188 -317 220
-571 350 -891 458 -467 157 -942 217 -1426 179z m295 -1019 c0 -6 73 -10 200
-10 193 0 200 -1 200 -20 0 -18 7 -20 80 -20 79 0 80 0 80 -25 0 -25 1 -25 80
-25 64 0 80 -3 80 -15 0 -11 11 -15 40 -15 29 0 40 -4 40 -15 0 -12 16 -15 80
-15 73 0 80 -2 80 -20 0 -17 8 -19 78 -22 l77 -3 3 -52 3 -53 40 0 c28 0 39
-4 39 -15 0 -11 11 -15 40 -15 36 0 40 -2 40 -25 0 -22 4 -25 40 -25 29 0 40
-4 40 -15 0 -8 9 -15 20 -15 12 0 32 -11 46 -25 17 -17 36 -25 59 -25 l35 0 0
-55 0 -55 36 0 c33 0 47 -11 160 -124 68 -68 124 -128 124 -135 0 -18 61 -70
76 -64 11 4 14 -5 14 -36 0 -34 3 -41 20 -41 17 0 20 -7 20 -40 0 -33 3 -40
20 -40 13 0 22 9 26 25 3 14 11 25 16 25 6 0 8 -10 4 -22 -3 -13 -6 -30 -6
-40 0 -16 -53 -42 -64 -31 -3 4 -6 15 -6 25 0 19 -31 25 -64 12 -13 -5 -12 -9
6 -24 l22 -17 -21 -54 c-22 -58 -30 -62 -98 -45 -30 8 -30 8 -7 -8 12 -10 22
-23 22 -30 0 -17 22 -26 66 -26 24 0 34 -5 34 -15 0 -11 11 -15 40 -15 37 0
40 2 41 28 l1 27 8 -30 c6 -22 8 -8 11 55 l3 85 6 -85 c3 -47 7 -66 8 -42 2
31 6 42 18 42 14 0 16 12 12 95 -4 92 -3 96 18 101 12 3 35 4 50 1 22 -3 19
-4 -13 -6 -24 0 -43 -5 -43 -11 0 -6 98 -10 275 -10 l275 0 0 -70 0 -70 -197
-2 c-118 0 -180 -4 -153 -8 l45 -7 -42 -1 -43 -2 0 -70 0 -70 173 -2 172 -3 3
-44 c7 -91 16 -86 -178 -83 l-170 3 1 -68 c2 -56 3 -61 8 -28 4 28 13 43 30
51 13 7 26 16 30 21 3 4 44 5 91 2 l85 -5 -85 -4 c-75 -3 -80 -4 -40 -10 l45
-7 -45 -3 c-26 -1 -35 -5 -22 -7 27 -5 28 -19 2 -35 -24 -15 -27 -48 -4 -48 8
0 12 -4 9 -10 -9 -15 -92 -12 -98 3 -3 7 -6 5 -6 -5 -1 -17 15 -18 204 -18
l206 0 -3 -67 -3 -68 -242 -3 c-151 -1 -243 -6 -243 -12 0 -6 71 -11 183 -12
l182 -2 -145 -6 c-127 -5 -135 -6 -60 -9 75 -4 80 -5 40 -11 l-45 -7 43 -1
c23 -1 42 -6 42 -11 0 -6 17 -11 38 -13 20 -2 -17 -3 -83 -2 l-120 3 114 -9
c62 -5 119 -11 125 -14 6 -2 -62 -5 -151 -5 -102 -1 -163 -5 -163 -11 0 -6 91
-10 253 -10 140 0 256 -2 258 -4 2 -3 3 -25 1 -50 l-4 -46 -271 0 c-149 0
-268 -2 -266 -4 2 -2 58 -7 123 -10 120 -6 171 -16 81 -16 -75 0 -50 -7 50
-15 50 -4 124 -10 165 -13 117 -11 -880 -17 -2620 -17 -1436 0 -2578 10 -2567
22 3 2 102 5 220 5 119 1 222 5 229 9 7 5 -36 9 -101 9 -63 0 -112 3 -108 6 3
3 77 9 164 13 145 7 133 8 -148 9 l-307 2 -4 46 c-2 25 -1 47 1 50 2 2 110 4
240 5 141 0 228 4 216 9 -11 5 -36 9 -55 10 l-35 2 30 8 c27 7 25 8 -20 10
-27 2 -40 5 -27 7 12 2 22 8 22 13 0 5 6 10 13 13 6 2 3 3 -8 1 -11 -2 -27 1
-35 6 -11 7 -4 10 25 12 22 1 2 5 -45 8 l-85 6 68 2 c37 1 67 7 67 12 0 6 -64
10 -172 10 l-173 0 0 370 0 369 218 3 c119 2 217 0 217 -3 0 -4 20 -10 44 -13
83 -13 156 -83 156 -151 0 -13 5 -27 11 -31 15 -9 2 51 -22 98 -22 43 -23 48
-9 48 6 0 10 -7 10 -15 0 -8 4 -15 9 -15 5 0 7 9 4 20 -6 21 13 28 20 8 2 -7
3 -5 2 4 -4 24 63 98 88 98 16 0 18 3 9 12 -7 7 -12 29 -12 50 0 38 0 38 40
38 l40 0 0 40 c0 22 4 40 9 40 6 0 11 17 13 38 2 30 7 38 26 40 18 3 22 10 22
43 l0 39 45 0 45 0 0 40 c0 40 0 40 40 40 l39 0 3 77 3 77 38 1 c20 1 37 -2
37 -7 0 -4 18 -8 40 -8 36 0 40 3 40 25 0 23 3 25 49 25 41 0 53 4 69 25 17
21 28 25 71 25 l51 0 0 55 0 55 40 0 c36 0 40 3 40 25 0 23 4 25 40 25 29 0
40 4 40 15 0 12 16 15 80 15 47 0 80 4 80 10 0 6 18 10 40 10 29 0 40 4 40 15
0 12 16 15 80 15 79 0 80 0 80 25 l0 25 120 0 c99 0 120 3 120 15 0 11 -18 15
-77 18 -43 3 29 3 160 1 205 -3 237 -2 237 11 0 11 11 15 40 15 22 0 40 -4 40
-10z m2080 -984 c0 -2 -7 -6 -15 -10 -8 -3 -15 -1 -15 4 0 6 7 10 15 10 8 0
15 -2 15 -4z m213 -23 c-40 -2 -106 -2 -145 0 -40 1 -8 3 72 3 80 0 112 -2 73
-3z m-4560 -20 c-7 -2 -21 -2 -30 0 -10 3 -4 5 12 5 17 0 24 -2 18 -5z m241
-48 c-7 -17 -7 -17 -31 -8 -16 6 -15 8 7 14 14 4 26 7 27 8 1 1 0 -6 -3 -14z
m4073 -47 c-2 -13 -4 -3 -4 22 0 25 2 35 4 23 2 -13 2 -33 0 -45z m-137 -85
c-11 -17 -11 -17 -6 0 3 10 6 24 7 30 0 9 2 9 5 0 3 -7 0 -20 -6 -30z m370
-23 c0 -5 -2 -10 -4 -10 -3 0 -8 5 -11 10 -3 6 -1 10 4 10 6 0 11 -4 11 -10z
m73 -97 c-7 -2 -19 -2 -25 0 -7 3 -2 5 12 5 14 0 19 -2 13 -5z m80 0 c-7 -2
-19 -2 -25 0 -7 3 -2 5 12 5 14 0 19 -2 13 -5z m160 -710 c-7 -2 -19 -2 -25 0
-7 3 -2 5 12 5 14 0 19 -2 13 -5z m-5110 -10 c-24 -2 -62 -2 -85 0 -24 2 -5 4
42 4 47 0 66 -2 43 -4z m5060 -10 c-13 -2 -33 -2 -45 0 -13 2 -3 4 22 4 25 0
35 -2 23 -4z m-4393 -154 c169 -27 260 -128 260 -288 0 -121 -68 -216 -185
-260 -49 -19 -82 -22 -221 -24 -129 -2 -165 1 -169 11 -8 20 -6 558 2 565 10
11 241 8 313 -4z m714 -61 c135 -293 217 -478 219 -495 2 -13 5 -13 -67 -13
l-53 0 -26 60 -26 60 -139 0 -139 0 -27 -60 -27 -60 -60 0 c-32 0 -59 1 -59 3
0 7 49 125 78 187 16 36 60 133 97 215 37 83 72 156 77 163 6 7 33 12 64 12
l55 0 33 -72z m716 22 l0 -49 -92 -3 -93 -3 0 -135 c0 -74 -1 -181 -3 -237
l-2 -103 -60 0 -60 0 0 240 0 239 -92 -1 -93 -1 -3 38 c-6 68 -18 65 253 65
l245 0 0 -50z m429 -40 c21 -47 53 -116 71 -155 28 -60 68 -148 136 -302 l14
-33 -70 0 c-43 0 -70 4 -70 11 0 6 -10 33 -21 60 l-21 49 -142 0 -141 0 -23
-60 -24 -60 -64 0 -64 0 14 33 c20 46 178 400 215 480 l32 68 60 -3 60 -3 38
-85z m671 66 c19 -10 37 -20 38 -21 2 -2 -5 -24 -17 -49 l-20 -46 -43 20 c-72
33 -194 25 -220 -14 -13 -20 -8 -52 10 -69 10 -9 52 -24 93 -33 167 -37 223
-85 216 -187 -4 -72 -26 -103 -97 -139 -44 -23 -66 -28 -129 -28 -87 0 -176
22 -216 54 l-27 22 21 42 c12 23 23 42 25 42 2 0 25 -12 51 -27 56 -31 174
-43 214 -21 38 20 47 43 32 72 -16 30 -19 31 -140 62 -57 15 -108 35 -129 50
-104 80 -70 233 63 282 48 18 233 10 275 -12z m290 -171 c4 -156 8 -196 23
-222 22 -41 51 -61 102 -67 62 -9 105 12 132 63 22 42 23 55 23 228 l0 183 60
0 60 0 0 -189 c0 -143 -4 -199 -15 -232 -38 -106 -118 -159 -243 -159 -116 0
-197 45 -238 134 -23 48 -24 61 -24 254 l0 203 58 -3 57 -3 5 -190z m962 168
c30 -14 52 -32 62 -52 31 -58 14 -165 -30 -189 -14 -8 -11 -12 18 -30 43 -27
58 -59 58 -125 -1 -58 -13 -86 -50 -115 -43 -33 -90 -41 -277 -46 l-183 -4 -2
87 c-2 133 -2 184 0 350 l2 153 178 -4 c153 -3 183 -7 224 -25z m765 -660 c-2
-16 -4 -5 -4 22 0 28 2 40 4 28 2 -13 2 -35 0 -50z m-5392 -53 c3 -5 1 -10 -4
-10 -6 0 -11 5 -11 10 0 6 2 10 4 10 3 0 8 -4 11 -10z m5318 -7 c-13 -2 -33
-2 -45 0 -13 2 -3 4 22 4 25 0 35 -2 23 -4z m10 -20 c-7 -2 -19 -2 -25 0 -7 3
-2 5 12 5 14 0 19 -2 13 -5z m-466 -875 c-2 -13 -4 -3 -4 22 0 25 2 35 4 23 2
-13 2 -33 0 -45z m-80 -160 c-2 -13 -4 -3 -4 22 0 25 2 35 4 23 2 -13 2 -33 0
-45z m-47 -26 c0 -10 -22 -32 -32 -32 -4 0 -8 9 -8 20 0 13 7 20 20 20 11 0
20 -4 20 -8z m-3455 -586 c20 3 20 3 1 -12 -11 -8 -23 -20 -28 -26 -4 -8 -7 6
-7 32 1 30 3 38 7 24 5 -14 14 -20 27 -18z m165 15 c0 -5 -7 -14 -15 -21 -16
-14 -18 -10 -9 14 6 17 24 22 24 7z m167 -246 c-4 -8 -11 -15 -17 -15 -7 0 -7
6 0 21 13 23 26 19 17 -6z m43 14 c0 -5 6 -7 13 -3 7 4 9 3 4 -2 -5 -5 -11 -8
-13 -6 -3 2 -13 -5 -22 -15 -9 -10 -14 -14 -9 -9 4 6 7 18 7 28 0 10 5 18 10
18 6 0 10 -5 10 -11z m445 -99 c3 -5 1 -10 -4 -10 -6 0 -11 5 -11 10 0 6 2 10
4 10 3 0 8 -4 11 -10z m-580 -10 c3 -5 1 -10 -4 -10 -6 0 -11 5 -11 10 0 6 2
10 4 10 3 0 8 -4 11 -10z m534 -3 c-18 -14 -14 -37 7 -37 8 0 14 -4 14 -10 0
-15 -36 -12 -49 3 -6 8 -8 17 -4 20 3 4 0 7 -8 7 -8 1 -3 7 11 15 31 17 51 19
29 2z m28 -23 c-3 -3 -12 -4 -19 -1 -8 3 -5 6 6 6 11 1 17 -2 13 -5z m-112
-24 c3 -5 -1 -10 -10 -10 -11 0 -15 -5 -11 -15 3 -8 1 -15 -3 -15 -5 0 -11 6
-13 12 -3 9 -12 8 -31 -5 -14 -9 -30 -17 -34 -17 -4 0 12 14 37 30 49 33 56
35 65 20z m925 7 c0 -2 -10 -12 -22 -23 l-23 -19 19 23 c18 21 26 27 26 19z
m-174 -51 c-15 -17 -27 -23 -31 -16 -4 6 6 22 22 36 35 30 42 15 9 -20z m-481
14 c3 -5 2 -10 -4 -10 -5 0 -13 5 -16 10 -3 6 -2 10 4 10 5 0 13 -4 16 -10z
m-765 -4 c0 -3 -4 -8 -10 -11 -5 -3 -10 -1 -10 4 0 6 5 11 10 11 6 0 10 -2 10
-4z m490 -26 c-8 -5 -19 -10 -25 -10 -5 0 -3 5 5 10 8 5 20 10 25 10 6 0 3 -5
-5 -10z m783 -9 c-6 -25 -39 -55 -47 -43 -3 5 3 18 14 29 10 12 16 24 13 27
-4 3 1 6 9 6 11 0 14 -6 11 -19z m-62 -3 c1 -7 1 -17 0 -22 -3 -16 11 -46 19
-41 18 11 22 -18 5 -33 -14 -14 -17 -14 -13 -2 3 8 -3 27 -14 42 -11 16 -16
32 -13 38 3 5 -2 10 -12 10 -15 0 -16 2 -3 10 20 13 30 12 31 -2z m109 6 c0
-8 -19 -13 -24 -6 -3 5 1 9 9 9 8 0 15 -2 15 -3z m-600 -14 c-8 -5 -19 -10
-25 -10 -5 0 -3 5 5 10 8 5 20 10 25 10 6 0 3 -5 -5 -10z m460 -19 c0 -5 -9
-11 -20 -14 -22 -6 -28 8 -7 16 19 8 27 8 27 -2z m-442 -26 c-3 -3 -9 2 -12
12 -6 14 -5 15 5 6 7 -7 10 -15 7 -18z m188 -31 c-6 -6 -15 -10 -20 -7 -4 3
-2 9 5 14 11 7 9 9 -6 9 -43 0 -94 -13 -89 -22 4 -6 -3 -7 -17 -3 l-24 8 25
-21 c14 -11 23 -23 20 -26 -3 -3 -18 5 -33 18 l-26 23 22 11 c61 32 173 29
143 -4z m263 22 c10 -12 8 -13 -8 -9 -12 3 -18 9 -15 14 7 12 10 11 23 -5z
m-269 -126 c8 -5 11 -10 5 -10 -5 0 -17 5 -25 10 -8 5 -10 10 -5 10 6 0 17 -5
25 -10z"/>
<path d="M6886 6681 c-3 -5 4 -11 16 -14 29 -8 32 -4 8 11 -10 6 -21 8 -24 3z"/>
<path d="M3283 6623 c15 -2 39 -2 55 0 15 2 2 4 -28 4 -30 0 -43 -2 -27 -4z"/>
<path d="M6833 6623 c9 -2 23 -2 30 0 6 3 -1 5 -18 5 -16 0 -22 -2 -12 -5z"/>
<path d="M6733 6613 c9 -2 23 -2 30 0 6 3 -1 5 -18 5 -16 0 -22 -2 -12 -5z"/>
<path d="M3207 6603 c-3 -5 20 -7 51 -5 98 5 110 9 30 11 -42 0 -79 -2 -81 -6z"/>
<path d="M3438 6603 c18 -2 45 -2 60 0 15 2 0 4 -33 4 -33 0 -45 -2 -27 -4z"/>
<path d="M6853 6603 c9 -2 23 -2 30 0 6 3 -1 5 -18 5 -16 0 -22 -2 -12 -5z"/>
<path d="M6773 6593 c9 -2 25 -2 35 0 9 3 1 5 -18 5 -19 0 -27 -2 -17 -5z"/>
<path d="M3248 6583 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M3378 6583 c28 -2 76 -2 105 0 28 2 5 3 -53 3 -58 0 -81 -1 -52 -3z"/>
<path d="M6678 6583 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M6853 6583 c15 -2 37 -2 50 0 12 2 0 4 -28 4 -27 0 -38 -2 -22 -4z"/>
<path d="M6590 6550 c-8 -5 -10 -10 -5 -10 6 0 17 5 25 10 8 5 11 10 5 10 -5
0 -17 -5 -25 -10z"/>
<path d="M6555 6530 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0
-8 -4 -11 -10z"/>
<path d="M2622 6358 l3 -83 115 4 c127 4 164 16 174 57 9 33 -21 86 -54 95
-14 4 -74 7 -133 8 l-108 1 3 -82z m275 -10 c-3 -8 -6 -5 -6 6 -1 11 2 17 5
13 3 -3 4 -12 1 -19z m-10 -34 c-3 -3 -12 -4 -19 -1 -8 3 -5 6 6 6 11 1 17 -2
13 -5z m-47 -14 c-8 -5 -31 -9 -50 -8 l-35 1 40 7 c59 11 61 11 45 0z"/>
<path d="M3206 6428 c3 -5 47 -7 97 -7 102 2 92 7 -25 11 -42 2 -74 0 -72 -4z"/>
<path d="M6758 6433 c18 -2 45 -2 60 0 15 2 0 4 -33 4 -33 0 -45 -2 -27 -4z"/>
<path d="M3448 6423 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M6687 6416 c-17 -13 -16 -14 6 -12 13 0 24 7 24 14 0 15 -7 15 -30
-2z"/>
<path d="M6654 6369 c-3 -6 -2 -15 3 -20 5 -5 9 -1 9 11 0 23 -2 24 -12 9z"/>
<path d="M7173 6148 c0 -176 2 -210 8 -138 10 136 10 343 0 358 -4 7 -8 -91
-8 -220z"/>
<path d="M3090 6339 c0 -11 -5 -30 -11 -42 -10 -21 -10 -21 5 -3 15 18 22 66
11 66 -3 0 -5 -9 -5 -21z"/>
<path d="M3111 6344 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M6855 6300 c-3 -5 -2 -10 4 -10 5 0 13 5 16 10 3 6 2 10 -4 10 -5 0
-13 -4 -16 -10z"/>
<path d="M3026 6235 c-11 -8 -18 -16 -15 -18 2 -2 19 -14 37 -27 19 -12 43
-37 53 -54 12 -20 19 -25 19 -14 0 9 -11 29 -24 45 -21 24 -22 29 -8 39 16 12
9 34 -11 34 -7 0 -6 -4 3 -10 13 -9 13 -11 0 -20 -19 -13 -42 -9 -48 9 -3 8 0
11 5 8 5 -3 10 0 10 8 0 8 -1 15 -1 15 -1 0 -10 -7 -20 -15z"/>
<path d="M3105 6240 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0
-7 -4 -4 -10z"/>
<path d="M6920 6240 c8 -5 20 -10 25 -10 6 0 3 5 -5 10 -8 5 -19 10 -25 10 -5
0 -3 -5 5 -10z"/>
<path d="M6970 6226 c0 -2 12 -12 28 -21 l27 -18 -19 21 c-17 20 -36 29 -36
18z"/>
<path d="M2622 6053 l3 -88 120 0 c137 0 177 12 195 56 17 40 5 76 -33 99 -27
17 -50 20 -160 20 l-128 0 3 -87z m268 57 c8 -5 11 -10 5 -10 -5 0 -17 5 -25
10 -8 5 -10 10 -5 10 6 0 17 -5 25 -10z m20 -110 c0 -5 -4 -10 -10 -10 -5 0
-10 5 -10 10 0 6 5 10 10 10 6 0 10 -4 10 -10z m-207 -17 c-13 -2 -33 -2 -45
0 -13 2 -3 4 22 4 25 0 35 -2 23 -4z"/>
<path d="M6718 6123 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z"/>
<path d="M6761 6116 c2 -2 18 -6 34 -10 22 -5 26 -4 15 4 -14 9 -59 15 -49 6z"/>
<path d="M7140 6078 c0 -23 2 -39 5 -37 9 10 13 79 4 79 -5 0 -9 -19 -9 -42z"/>
<path d="M7074 6080 c7 -63 -12 -125 -53 -169 -44 -47 -40 -54 6 -12 18 16 35
41 39 55 3 14 10 29 15 32 12 7 10 83 -2 109 -7 16 -8 12 -5 -15z"/>
<path d="M3120 6026 c0 -14 5 -26 10 -26 6 0 10 9 10 19 0 11 -4 23 -10 26 -6
4 -10 -5 -10 -19z"/>
<path d="M6891 6034 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M7100 6029 c0 -13 5 -31 10 -39 7 -11 8 -5 4 20 -8 43 -14 51 -14 19z"/>
<path d="M3215 6030 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0
-8 -4 -11 -10z"/>
<path d="M3260 6035 c0 -5 5 -17 10 -25 5 -8 10 -10 10 -5 0 6 -5 17 -10 25
-5 8 -10 11 -10 5z"/>
<path d="M3195 6000 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0
-8 -4 -11 -10z"/>
<path d="M3109 5958 c-7 -18 -14 -37 -16 -43 -3 -5 2 -2 10 7 8 10 16 16 19
13 2 -3 5 9 5 25 0 17 -1 30 -3 30 -1 0 -8 -15 -15 -32z"/>
<path d="M3320 5980 c8 -5 20 -10 25 -10 6 0 3 5 -5 10 -8 5 -19 10 -25 10 -5
0 -3 -5 5 -10z"/>
<path d="M6688 5973 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z"/>
<path d="M7087 5961 c-4 -17 -3 -21 5 -13 5 5 8 16 6 23 -3 8 -7 3 -11 -10z"/>
<path d="M3065 5890 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0
-8 -4 -11 -10z"/>
<path d="M3035 5870 c-3 -5 -33 -15 -65 -22 -36 -7 -60 -17 -60 -25 0 -17 25
-17 42 0 7 7 32 18 56 25 23 7 42 17 42 22 0 13 -7 13 -15 0z"/>
<path d="M2848 5823 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z"/>
<path d="M7298 5793 c12 -2 30 -2 40 0 9 3 -1 5 -23 4 -22 0 -30 -2 -17 -4z"/>
<path d="M3079 5316 c-1 -3 -1 -15 -1 -26 0 -11 0 -94 1 -185 l1 -165 93 0
c69 0 103 5 134 19 75 35 117 131 94 218 -25 93 -88 132 -227 140 -52 3 -94 3
-95 -1z"/>
<path d="M3848 5187 c-20 -50 -40 -100 -44 -109 -6 -16 2 -18 86 -18 84 0 92
2 86 18 -44 116 -79 202 -85 202 -3 0 -23 -42 -43 -93z"/>
<path d="M4978 5173 l-44 -108 89 -3 c49 -1 91 -1 93 0 4 5 -80 217 -87 218
-3 0 -26 -48 -51 -107z"/>
<path d="M6770 5250 l0 -70 88 0 c107 0 152 21 152 70 0 56 -27 70 -140 70
l-100 0 0 -70z"/>
<path d="M6770 5005 l0 -75 100 0 c135 0 170 18 170 86 0 17 -10 30 -32 44
-27 16 -51 20 -135 20 l-103 0 0 -75z"/>
<path d="M7570 4600 c0 -29 4 -40 15 -40 11 0 15 11 15 40 0 29 -4 40 -15 40
-11 0 -15 -11 -15 -40z"/>
<path d="M5735 3250 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0
-8 -4 -11 -10z"/>
<path d="M4129 3213 c-13 -16 -12 -17 4 -4 9 7 17 15 17 17 0 8 -8 3 -21 -13z"/>
<path d="M4035 3199 c-4 -6 -12 -8 -19 -6 -6 3 -12 -4 -12 -14 0 -17 2 -17 23
3 13 12 23 23 23 25 0 7 -9 2 -15 -8z"/>
<path d="M5840 3180 c-6 -11 -8 -20 -6 -20 3 0 10 9 16 20 6 11 8 20 6 20 -3
0 -10 -9 -16 -20z"/>
<path d="M3976 3143 c-6 -14 -5 -15 5 -6 7 7 10 15 7 18 -3 3 -9 -2 -12 -12z"/>
<path d="M4054 3124 c-34 -43 -44 -65 -20 -45 22 19 59 71 54 77 -3 2 -18 -12
-34 -32z"/>
<path d="M3950 3109 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10
-5 -10 -11z"/>
<path d="M4597 3069 c7 -7 15 -10 18 -7 3 3 -2 9 -12 12 -14 6 -15 5 -6 -5z"/>
<path d="M5535 3020 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0
-8 -4 -11 -10z"/>
<path d="M5079 3003 c-13 -16 -12 -17 4 -4 16 13 21 21 13 21 -2 0 -10 -8 -17
-17z"/>
<path d="M4329 2993 c-13 -16 -12 -17 4 -4 16 13 21 21 13 21 -2 0 -10 -8 -17
-17z"/>
<path d="M5489 2974 c-23 -25 -23 -26 -2 -13 13 7 25 19 27 26 8 19 2 16 -25
-13z"/>
<path d="M3966 2974 c-5 -14 -4 -15 9 -4 17 14 19 20 6 20 -5 0 -12 -7 -15
-16z"/>
<path d="M5021 2938 c-18 -21 -29 -38 -25 -37 10 1 68 68 63 73 -2 1 -19 -15
-38 -36z"/>
<path d="M4249 2958 c-1 -2 -2 -15 -3 -30 l-2 -28 28 27 c31 29 39 46 10 20
-23 -21 -36 -22 -28 -2 4 12 0 23 -5 13z"/>
<path d="M4770 2956 c0 -2 7 -7 16 -10 8 -3 12 -2 9 4 -6 10 -25 14 -25 6z"/>
<path d="M5741 2810 c-4 -144 -5 -149 -11 -70 -6 84 -6 84 -10 -50 -4 -129 -4
-132 -10 -55 l-6 80 -4 -80 -4 -80 -6 70 c-5 51 -7 59 -8 28 -2 -43 -2 -43
-41 -43 -29 0 -41 -5 -44 -17 -3 -10 -4 3 -2 30 1 26 -2 50 -6 53 -5 3 -9
-216 -9 -496 0 -473 1 -501 18 -496 9 3 42 8 73 11 31 4 61 10 68 14 8 5 10
166 8 632 -1 343 -4 554 -6 469z"/>
<path d="M3761 2934 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M5426 2903 c-6 -14 -5 -15 5 -6 7 7 10 15 7 18 -3 3 -9 -2 -12 -12z"/>
<path d="M4975 2880 c-4 -6 -11 -7 -17 -4 -7 4 -8 2 -4 -5 6 -9 11 -9 22 0 14
11 18 19 10 19 -3 0 -8 -5 -11 -10z"/>
<path d="M4180 2855 c-33 -35 -21 -38 15 -4 17 16 25 29 19 29 -6 0 -21 -11
-34 -25z"/>
<path d="M4910 2876 c0 -3 9 -10 20 -16 11 -6 20 -8 20 -6 0 3 -9 10 -20 16
-11 6 -20 8 -20 6z"/>
<path d="M5544 2855 c-15 -14 -25 -27 -22 -30 2 -3 17 9 33 25 35 36 27 40
-11 5z"/>
<path d="M4130 2825 c0 -8 2 -15 4 -15 2 0 6 7 10 15 3 8 1 15 -4 15 -6 0 -10
-7 -10 -15z"/>
<path d="M5583 2766 c0 -39 4 -61 9 -54 10 17 10 89 -1 106 -5 9 -8 -12 -8
-52z"/>
<path d="M5479 2783 c-13 -16 -12 -17 4 -4 16 13 21 21 13 21 -2 0 -10 -8 -17
-17z"/>
<path d="M5683 2760 c0 -25 2 -35 4 -22 2 12 2 32 0 45 -2 12 -4 2 -4 -23z"/>
</g>
</svg>

    </Box>
  );
  if (disabledLink) {
    return <>{logo}</>;
  }

  return <RouterLink to="">{logo}</RouterLink>
}
